import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'amazon-status',
  templateUrl: './status.component.html',
  styleUrls: ['./status.component.scss']
})
export class StatusComponent {
  public message: string;
  public isUploadStatus = false;
  public statusData = [];
  public successCount = 0;
  public failedCount = 0;
  public totalCount = 0;
  public validationFailedCount = 0;
  public validationSuccessCount = 0;
  public isCarrier: boolean = false;
  public isAction: boolean = false;
  public isStore : boolean  = false;

  constructor(
    private dialogRef: MatDialogRef<StatusComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    console.log(this.data, "data in status component");
    
    // Extract response data
    const responseData = this.data.hasOwnProperty("response") ? this.data.response : this.data;
    
    // Set counts if they exist in the response
    this.successCount = responseData?.successCount || 0;
    this.failedCount = responseData?.failedCount || 0;
    this.totalCount = responseData?.totalCount || 0;
    this.validationFailedCount = responseData?.validationFailedCount || 0;
    this.validationSuccessCount = responseData?.validationSuccessCount || 0;
    this.isCarrier = this.data.isCarrier || false;
    this.isAction = this.data.isAction || false;
    this.isStore = this.data.isStore || false;
    
    // Extract error/failure data for table display
    if (this.data.category === "csv-upload") {
      // Try to get errors from different possible locations
      this.statusData = responseData?.errors || 
                       responseData?.error?.error?.errors || 
                       responseData?.error?.errors || 
                       [];
      
      // Determine success/failure and set appropriate message
      const hasFailures = this.failedCount > 0 || 
                         this.validationFailedCount > 0 || 
                         this.statusData.length > 0;

      if(this.isCarrier) {
      if (hasFailures) {
        const totalFailures = this.failedCount + this.validationFailedCount;
        this.message = `Upload failed: ${totalFailures} of ${this.totalCount} records failed`;
      } else {
        this.message = `File uploaded successfully: ${this.successCount} of ${this.totalCount} records processed`;
      }
    }
    } else {
      this.statusData = responseData;
      this.message = "File uploaded successfully";
    }
  }

  /**
   * @method - called when the modal is closed
   * @param param - status
   */
  closeModal(status: boolean) {
    this.dialogRef.close(status);
  }
}
